import { URLState } from '../../models';

export function getInitialUrlState(): URLState {
  return {
    url: window.location.href,
    stateFromUrl: false
  };
}
